import { createClient } from '@/shared/api';
import GENERATE_HOLTER_REPORT_COMMENTS from '@/entities/report/api/mutations/generateHolterReportComments';
import type {
  GenerateHolterReportCommentsMutation,
  GenerateHolterReportCommentsMutationVariables,
} from '@/shared/api/generated/graphql';

export type GenerateHolterReportCommentsResult = {
  isSuccess: boolean;
  message: string;
  processingStudyFids: string[];
  isReady: boolean;
  simultaneousStudyLimit: number;
};

// TODO(ts): typed as the GenerateHolterReportCommentsInput GraphQL input once its server-side shape is documented
/**
 * Asks the server to generate the narrative comments for a holter report. Runs the generateHolterReportComments mutation and throws the server message on failure.
 *
 * @param input - Mutation input identifying the report to comment on.
 * @returns A promise resolving to the generateHolterReportComments result.
 */
const handleGenerateHolterReportComment = async (input: any) => {
  const client = await createClient();
  const result = await client.mutate<
    GenerateHolterReportCommentsMutation,
    GenerateHolterReportCommentsMutationVariables
  >({
    mutation: GENERATE_HOLTER_REPORT_COMMENTS,
    variables: {
      input,
    },
  });
  const { data } = result;
  const { generateHolterReportComments } = data;
  if (!generateHolterReportComments.isSuccess) {
    throw new Error(generateHolterReportComments.message);
  }
  return generateHolterReportComments;
};

export default handleGenerateHolterReportComment;
